import {ProfileMenuId} from '../../../profileMenu/constants';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {PcProfileMenuItem} from './PcProfileMenuItem.interface';

export const PC_PROFILE_MENU_LIST = [
  ProfileMenuId.Alarm,
  ProfileMenuId.PassVip,
  ProfileMenuId.Cash,
  ProfileMenuId.Voucher,
  ProfileMenuId.Reply,
  ProfileMenuId.Notice,
  ProfileMenuId.Customer,
  ProfileMenuId.Coupon,
  ProfileMenuId.Settings,
];

/**
 * XXX: 각 프로필 메뉴에 대한 href가 결정되면 채워야 합니다.
 */
export const PC_PROFILE_MENU_MAP: {
  [key in ProfileMenuId]?: PcProfileMenuItem;
} = {
  [ProfileMenuId.PassVip]: {
    uid: ProfileMenuId.PassVip,
    title: '캐시 PASS VIP',
    icon: IconType.MenuCashPassVip,
    href: '',
  },
  [ProfileMenuId.Cash]: {
    uid: ProfileMenuId.Cash,
    title: '캐시 내역',
    icon: IconType.MenuCash,
    href: '/history/cash',
  },
  [ProfileMenuId.Voucher]: {
    uid: ProfileMenuId.Voucher,
    title: '이용권 내역',
    icon: IconType.MenuCoupon,
    href: '/history/ticket',
  },
  [ProfileMenuId.Reply]: {
    uid: ProfileMenuId.Reply,
    title: '댓글 내역',
    icon: IconType.MenuComment,
    href: '/comment/my',
  },
  [ProfileMenuId.Coupon]: {
    uid: ProfileMenuId.Coupon,
    title: '쿠폰 등록',
    icon: IconType.MenuCouponRegister,
    href: '/redeem',
  },
  [ProfileMenuId.Settings]: {
    uid: ProfileMenuId.Settings,
    title: '설정',
    icon: IconType.MenuSetting,
    href: '/settings',
  },
  [ProfileMenuId.Alarm]: {
    uid: ProfileMenuId.Alarm,
    title: '알림',
    icon: IconType.MenuAlarm,
    href: '/mynews',
  },
  [ProfileMenuId.Notice]: {
    uid: ProfileMenuId.Notice,
    title: '공지사항',
    icon: IconType.MenuNotice,
    href: '/notice',
  },
  [ProfileMenuId.Customer]: {
    uid: ProfileMenuId.Customer,
    title: '고객센터',
    icon: IconType.MenuCustomer,
    href: '/support',
  },
};
